// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alpha-code-tag[data-v-92434cb2] {\n  font-size: 0.55rem;\n}\n.alpha-code-tag.alpha-code-tag[data-v-92434cb2]:not(:last-child) {\n  margin-right: 0.15rem;\n}\n.alpha-code-tag.alpha-code-tag[data-v-92434cb2]:not(body) {\n  padding-left: 0.2rem;\n  padding-right: 0.2rem;\n}", ""]);
// Exports
module.exports = exports;
